module.exports = {
    PAGE_NAME: "Trade Mirror",
    // API_URL: "https://mirror.ptx.ro",
    API_URL: ""
}